export const SAMPLE_HTML = `<style>
  .card {
    font-family: sans-serif;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  .card h3 {
    margin-top: 0;
  }
  .card .actions {
    display: flex;
    gap: 8px;
    margin-top: 12px;
  }
  .card button {
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 14px;
  }
  .card .primary {
    background: #4183c4;
    color: #fff;
  }
  .card .secondary {
    background: #f0f0f0;
    color: #333;
  }
  .card a.external {
    color: #4183c4;
    text-decoration: none;
    font-size: 12px;
  }
</style>
<div class="card">
  <h3>埋め込みカードのサンプル</h3>
  <p>サンドボックス内で表示される HTML/CSS ウィジェットです。</p>

  <div class="actions">
    <!-- 同タブ遷移 + GA4 計測を一発で: trillNavigate(url, params?) -->
    <button
      class="primary"
      onclick="trillNavigate('https://example.com/landing', {
      event_category: 'sample_card',
      event_label: 'primary_cta'
    })"
    >
      詳しく見る (same tab)
    </button>

    <!-- 計測のみ (遷移しない): trillTrack(action, params) -->
    <button
      class="secondary"
      onclick="trillTrack('タップ', {
      event_category: 'sample_card',
      event_label: 'secondary_action',
      non_interaction: false
    })"
    >
      お気に入り
    </button>
  </div>

  <p>
    <!-- ネイティブリンクで外部サイトを新規タブ表示 + 計測 -->
    <a
      class="external"
      href="https://example.com/external"
      target="_blank"
      rel="noopener"
      onclick="trillTrack('タップ', {
         event_category: 'sample_card',
         event_label: 'external_link',
         link_url: 'https://example.com/external'
       })"
    >
      外部サイトを新規タブで開く →
    </a>
  </p>
</div>`

export const SAMPLE_PLACEHOLDER = `例:
<style>
  .card {
    padding: 16px;
    border: 1px solid #ddd;
  }
</style>
<div class="card">
  <h3>タイトル</h3>
  <p>本文</p>

  <!-- 同タブ遷移 + 計測を一発で -->
  <button
    onclick="trillNavigate('https://example.com/landing', {
    event_category: 'sample_card',
    event_label: 'primary_cta'
  })"
  >
    詳しく見る
  </button>

  <!-- 計測のみ -->
  <button
    onclick="trillTrack('タップ', {
    event_category: 'sample_card',
    event_label: 'cta_button'
  })"
  >
    CTA
  </button>
</div>

許可されるタグ: div, span, p, h1-h6, ul/ol/li, a, img, button, style, svg,
table 系。許可されない: script (実体), iframe, form, object など。

onclick / onkeydown は trillTrack(action, params) または
trillNavigate(url, params?) の単一呼び出しのみ可。params は非空 object
(空の {} だと dataLayer に push されません)。

- trillTrack action サポート済み: タップ, 完読, page_view
- trillTrack params サポート済み: event_category, event_label, link_url, non_interaction
- trillNavigate url: http/https/相対 URL のみ (javascript:, data:, file:,
  localhost などは reject)。1 ページロードあたり 1 回まで navigate 可能。
- params 指定時は trillTrack タップ も自動発火し link_url が自動補完されます。

javascript:, vbscript:, expression(...), <script>, <iframe> などは禁止。`
